export default "__VITE_ASSET__BXZ$8fp7__"